<template>
  <div class="mobile-prototype-wrapper">
    <div class="toolbar">
      <div class="toolbar-wrapper">
        <a-radio-group
          v-model:value="requestPayload.status"
          @change="hanldeSearch"
          button-style="solid"
          size="small"
        >
          <a-radio-button value="1,2,3">试用样机</a-radio-button>
          <a-radio-button value="5">试用结束</a-radio-button>
          <a-radio-button value="4">样机转销售</a-radio-button>
        </a-radio-group>

        <a-button size="small" @click="handleSyncPrototype" :disabled="!useSyncButton"
          >同步</a-button
        >
        <a-button size="small" type="primary" @click="handleInsertMachine">新增</a-button>
      </div>

      <a-space>
        <staff
          :staff="requestPayload.applicant"
          @getChooseStaff="handleSelectStaff"
          :appointDepartment="loDepartment"
        >
        </staff>
        <a-input
          @change="hanldeSearch"
          v-model:value="requestPayload.prototypeSerial"
          placeholder="设备号"
          allowClear
          style="width: 4.5rem"
        ></a-input>
      </a-space>
    </div>

    <div class="prototype-wrapper">
      <template v-for="(item, index) in table.data" :key="item.id">
        <div class="prototype-item">
          <p>
            <span>申请人:</span> <span>{{ item.applicant }}</span>
          </p>
          <p>
            <span>客户信息:</span> <span>{{ item.customerReceiptDetails }}</span>
          </p>

          <p>
            <span>设备型号:</span> <span>{{ item.prototypeModel }}</span>
          </p>
          <p>
            <span>机身号:</span> <span>{{ item.prototypeSerial }}</span>
          </p>

          <p>
            <span>过期时间:</span> <span> {{ item.expiresDate }}</span>
          </p>

          <div class="action-wrapper">
            <a-dropdown style="width: 120px">
              <template #overlay>
                <a-menu @click="handleMenuClick($event, item)">
                  <a-menu-item key="update"> 修改 </a-menu-item>
                  <a-menu-item key="extendsion" v-if="requestPayload.status === '1,2,3'">
                    样机延期
                  </a-menu-item>
                  <a-menu-item key="delete"> 删除 </a-menu-item>
                </a-menu>
              </template>
              <a-button type="primary">
                操作
                <DownOutlined />
              </a-button>
            </a-dropdown>
          </div>
        </div>
      </template>
    </div>

    <div class="page">
      <a-pagination
        show-size-changer
        v-model:current="table.pageNum"
        v-model:pageSize="table.lineNum"
        :total="table.total"
        @change="hanldeUpdatePageNum"
      />
    </div>
    <machine-form ref="machineFormRef" @handleUpdateTable="getData"></machine-form>
    <extension-form ref="extensionFormRef" @handleUpdateTable="getData"></extension-form>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { DownOutlined } from "@ant-design/icons-vue";
import { useTable } from "@/views/notice/serve/table";
import { machineType, prototypeMachineStatus, loDepartment } from "../prototypeManagement/options";
import {
  getPrototypeRegistrationList,
  deletePrototypeRegistration,
  exportPrototype,
  syncDingtalkPrototype,
} from "@/request/view/prototypeManagement";
import staff from "@/components/chooseStaff/staffName.vue";
import { Toast, debounce, timeStampToTime } from "@/utils";
import machineForm from "./form.vue";
import extensionForm from "./extension.vue";

const {
  requestConfig,
  table,
  requestPayload,
  initPayload,
  getListData,
  deleteRecords,
  hanldeUpdatePageNum,
} = useTable();

requestConfig.pull_fn = getPrototypeRegistrationList;
requestConfig.delete_fn = deletePrototypeRegistration;

initPayload({
  applicant: null,
  applicantDept: null,
  lineNum: 10,
  lt3Days: null,
  pageNum: 1,
  prototypeSerial: null,
  prototypeType: null,
  prototypeModel: null,
  status: "1,2,3",
});

const getData = () => {
  getListData()
    .then(() => {
      console.log(table, "table");
    })
    .catch(() => {});
};

const hanldeSearch = () => {
  requestPayload.pageNum = 1;
  table.pageNum = 1;
  getData();
};

const handleSelectStaff = (e) => {
  const { staffUserName } = e;
  const staff = staffUserName[0];
  requestPayload.applicant = staff ? staff : null;
  hanldeSearch();
};

const useSyncButton = ref(true);

const handleSyncPrototype = async () => {
  try {
    useSyncButton.value = false;
    const data = await syncDingtalkPrototype();
    useSyncButton.value = true;
    if (!data || !data.code || !data.message) return Toast("warning", "同步失败", 3);
    const type = data.code === 200 ? "success" : "warning";
    Toast(type, data.message, 3);
    getData();
  } catch (error) {
    useSyncButton.value = true;
  }
};

const machineFormRef = ref();
const extensionFormRef = ref();

const handleInsertMachine = () => {
  machineFormRef.value.showModal("insert", { title: "样机管理" });
};

const handleUpdateMachine = (data) => {
  machineFormRef.value.showModal("update", { title: "样机管理", data });
};

const handleDeleteMachine = (data) => {
  deleteRecords([data.id], { title: "确认删除？" }).then(() => {
    getListData();
  });
};

const handleMenuClick = (e, data) => {
  const { key } = e;
  switch (key) {
    case "update":
      handleUpdateMachine(data);
      break;
    case "extendsion":
      handleExtension(data);
      break;
    case "delete":
      handleDeleteMachine(data);
      break;
    default:
      break;
  }
};

const handleExtension = (data) => {
  extensionFormRef.value.showModal(data);
};

getData();
</script>

<style lang="less" scoped>
.mobile-prototype-wrapper {
  .toolbar {
    height: 88px;
    padding: 10px 20px;
    box-shadow: 0 0 10px 0 #ccc;
    .toolbar-wrapper {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 10px;
    }
  }
  .page {
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 0 10px 0 #ccc;
  }
  .prototype-wrapper {
    height: calc(100vh - 138px);
    overflow: scroll;
    padding-top: 10px;
    .prototype-item {
      padding: 10px 15px;
      width: 9rem;
      margin: 0 auto 20px;
      box-shadow: 0 0 10px 0 #ccc;
      border-radius: 20px;
      font-size: 16px;
      position: relative;
      span {
        display: inline-block;
      }
      p {
        display: flex;
        justify-content: space-between;
        padding: 5px;
        letter-spacing: 1px;
        border-bottom: 1px solid #ccc;
      }
      p span:nth-child(1) {
        width: 2.2rem;
        font-weight: bold;
      }
      p span:nth-child(2) {
        width: 5.8rem;
      }
      p:nth-last-child(1) {
        border-bottom: none;
      }

      .action-wrapper {
        position: absolute;
        right: 20px;
        top: 7px;
      }
    }
  }

  .page {
    height: 50px;
  }
}
</style>
